import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import Header from "./Header";
import PHPDevelopmentImg1 from "./assets/img/PHPDevelopmentImg-1.png";
import AngularDevelopmentImg1 from "./assets/img/AngularDevelopmentImg-1.png";
import AngularDevelopmentImg2 from "./assets/img/AngularDevelopmentImg-2.png";
import productsliderImg1 from "./assets/img/productsliderImg-1.png";
import productsliderImg2 from "./assets/img/productsliderImg-2.png";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
const Angular = () => {
  const [lgShow, setLgShow] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    interest: "",
    message: "",
  });
  const [thankYouPopup, setThankYouPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await axios
      .post(
        "https://p506xqqura.execute-api.ap-south-1.amazonaws.com/contact",
        { ...formData, type: "contact" },
        { headers: { "Content-Type": "application/json" } },
      )
      .then(() => {
        setThankYouPopup(true);
        setFormData({ name: "", email: "", mobile: "", interest: "", message: "" });
        setLgShow(false);
        setShowThankYou(true);
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        alert("An error occurred while submitting the form. Please try again later.");
      });
  };

  return (
    <>
      <Helmet>
        <title>
          {" "}
          Leading Angular Development Services | Hummingtec Pvt Ltd
        </title>
        <meta
          name="description"
          content="Transform your web applications with leading Angular development services from Hummingtec. Our Angular experts deliver dynamic, responsive, and user-friendly solutions to enhance your digital strategy."
        />
        <meta
          name="keywords"
          content="Angular Development, Angular Development Services, humingtec, hummingtec, Hummingtec Pvt Ltd"
        />
        <link rel="canonical" href="https://www.hummingtec.com/Angular" />
      </Helmet>
      <Header></Header>
      <div className="mainContent">
        <div className="bannerWrap innerBanner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-9">
                <div className="titleWrap">
                  <h2>Angular Development</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="servTechIntro">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>Introduction</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap">
                  <p>
                    Angular is a platform and framework for building single-page
                    client applications using HTML and TypeScript. It's
                    developed and maintained by Google and offers a
                    comprehensive solution for developing efficient and
                    sophisticated web and mobile applications. At Hummingtec, we
                    harness the power of Angular to create dynamic, scalable,
                    and user-friendly applications that meet the evolving needs
                    of businesses in the digital age.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap flexRevMob">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadLt">
                  <h2>Why Choose Angular for Your Development Projects?</h2>
                  <p>
                    Angular provides a robust set of features that can be
                    utilized to build complex, high-performance web
                    applications. Its two-way data binding, modular development
                    structure, and extensive suite of tools make Angular an
                    ideal choice for enterprise-level applications, SPAs
                    (Single-Page Applications), and progressive web apps (PWAs).
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="imgWrap">
                  <img src={PHPDevelopmentImg1} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imgWrap">
                  <img
                    src={AngularDevelopmentImg1}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadRt">
                  <h2>Angular Frameworks and Applications</h2>
                  <p>
                    Angular is a versatile framework that can be applied to a
                    variety of development projects, including:
                  </p>
                  <ul>
                    <li>
                      <strong>1.</strong> Web Development
                    </li>
                    <li>
                      <strong>2.</strong> Mobile App Development
                    </li>
                    <li>
                      <strong>3.</strong> Enterprise Applications
                    </li>
                    <li>
                      <strong>4.</strong> E-commerce Sites
                    </li>
                    <li>
                      <strong>5.</strong> Content Management Systems
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugBenefitsWrap nodejsBenefitsWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>Our Angular Development Expertise</h2>
                  <p>
                    We specialize in a wide range of Angular development
                    services, including:
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <ul>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 512 512"
                        >
                          <g>
                            <path
                              d="M48 80h16v16H48zM80 80h16v16H80zM112 80h16v16h-16z"
                              fill="#9ceebd"
                              opacity="0.45"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M48 432h141.058l-4.364 48H160v16h176v-16h-24.694l-4.364-48H448a32.036 32.036 0 0 0 32-32V224h-16v128H32V128h208v-16H32V80a16.019 16.019 0 0 1 16-16h248V48H48a32.036 32.036 0 0 0-32 32v320a32.036 32.036 0 0 0 32 32zm247.24 48h-94.48l4.364-48h85.752zM464 368v32a16.019 16.019 0 0 1-16 16H48a16.019 16.019 0 0 1-16-16v-32z"
                              fill="#9ceebd"
                              opacity="1"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M240 384h16v16h-16zM376 192a48 48 0 1 0-48-48 48.055 48.055 0 0 0 48 48zm0-80a32 32 0 1 1-32 32 32.036 32.036 0 0 1 32-32z"
                              fill="#9ceebd"
                              opacity="0.45"
                              data-original="#9ceebd"
                            ></path>
                            <path
                              d="M275.159 78.868a7.993 7.993 0 0 0-7.8 4.928l-10.75 25.954a8 8 0 0 0 2.03 9l19.65 17.74v15.02l-19.65 17.74a8 8 0 0 0-2.03 9l10.75 25.954a8 8 0 0 0 7.8 4.928l26.439-1.35 10.62 10.62-1.35 26.439a8 8 0 0 0 4.928 7.8l25.954 10.75a8 8 0 0 0 9-2.03l17.74-19.65h15.02l17.74 19.65a8 8 0 0 0 9 2.03l25.954-10.75a8 8 0 0 0 4.928-7.8l-1.35-26.439 10.62-10.62 26.439 1.35a7.98 7.98 0 0 0 7.8-4.928l10.75-25.954a8 8 0 0 0-2.03-9l-19.65-17.74v-15.02l19.65-17.74a8 8 0 0 0 2.03-9l-10.75-25.95a8 8 0 0 0-7.8-4.928L450.4 80.218 439.782 69.6l1.35-26.439a8 8 0 0 0-4.928-7.8L410.25 24.609a8 8 0 0 0-9 2.03l-17.74 19.65h-15.02l-17.74-19.65a8 8 0 0 0-9-2.03l-25.95 10.75a8 8 0 0 0-4.928 7.8l1.35 26.439-10.622 10.62zM310.4 94.046 326.046 78.4a8 8 0 0 0 2.333-6.065l-1.244-24.351 15.522-6.429L359 59.65a8 8 0 0 0 5.938 2.639h22.13A8 8 0 0 0 393 59.65l16.34-18.1 15.522 6.429-1.244 24.351a8 8 0 0 0 2.333 6.065L441.6 94.046a8.012 8.012 0 0 0 6.065 2.333l24.351-1.244 6.429 15.522L460.35 127a8 8 0 0 0-2.639 5.938v22.13A8 8 0 0 0 460.35 161l18.1 16.34-6.429 15.522-24.351-1.244a7.992 7.992 0 0 0-6.065 2.333L425.954 209.6a8 8 0 0 0-2.333 6.065l1.244 24.351-15.522 6.429L393 228.35a8 8 0 0 0-5.938-2.639h-22.13A8 8 0 0 0 359 228.35l-16.34 18.1-15.522-6.429 1.244-24.351a8 8 0 0 0-2.333-6.065L310.4 193.954a8.015 8.015 0 0 0-6.065-2.333l-24.351 1.244-6.429-15.522L291.65 161a8 8 0 0 0 2.639-5.938v-22.13A8 8 0 0 0 291.65 127l-18.1-16.34 6.429-15.522 24.351 1.244a8.005 8.005 0 0 0 6.07-2.336zM104 160a8 8 0 0 0-8-8H64a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24H72v-16h16zM168 160a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16zM232 160a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16zM104 224a8 8 0 0 0-8-8H64a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24H72v-16h16zM168 224a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16zM232 224a8 8 0 0 0-8-8h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8zm-16 24h-16v-16h16zM96 280H64a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-8 32H72v-16h16zM160 280h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-8 32h-16v-16h16zM224 280h-32a8 8 0 0 0-8 8v32a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8v-32a8 8 0 0 0-8-8zm-8 32h-16v-16h16zM272 280h16v16h-16zM304 280h136v16H304zM256 312h152v16H256z"
                              fill="#9ceebd"
                              opacity="0.45"
                              data-original="#9ceebd"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Single-Page Applications (SPAs)</h2>
                        <p>
                          Crafting fast, responsive SPAs that offer a seamless
                          user experience similar to a desktop application.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 7111 7111"
                        >
                          <g>
                            <path
                              d="M6615 6205H495c-207 0-374-168-374-373V1666c0-205 168-373 374-373h401c54 0 97 43 97 97s-43 97-97 97H495c-99 0-179 81-179 179v4166c0 99 80 179 179 179h6120c98 0 179-80 179-179V1666c0-98-81-179-179-179h-401c-54 0-97-43-97-97s43-97 97-97h401c207 0 373 168 373 373v4166c2 207-166 373-373 373z"
                              fill="#9ccdee"
                              opacity="1"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M4411 7108H2703c-48 0-90-36-95-85-6-49 24-94 72-107 234-61 256-613 245-802-2-54 38-100 92-103 53-3 100 38 103 92 4 68 23 534-147 810h1168c-173-276-152-742-148-810 3-54 50-95 103-92 54 3 94 49 91 103-11 189 11 741 250 802 47 13 78 58 72 107-8 49-50 85-98 85z"
                              fill="#9ccdee"
                              opacity="1"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M4132 6712H2982c-54 0-97-43-97-97s43-97 97-97h1150c54 0 97 43 97 97s-45 97-97 97zM6892 5250H219c-55 0-98-43-98-97s43-97 98-97h6673c55 0 98 43 98 97s-45 97-98 97zM3772 5728h-436c-54 0-97-43-97-97s43-97 97-97h436c54 0 97 43 97 97s-43 97-97 97zM6001 4803H1108c-170 0-309-138-309-309V602c0-331 269-599 598-599h4316c330 0 598 270 598 599v3891c1 172-139 310-310 310zM1397 196c-223 0-404 182-404 404v3893c0 63 52 115 115 115h4893c64 0 116-52 116-115V600c0-223-182-404-404-404z"
                              fill="#9ccdee"
                              opacity="1"
                              data-original="#9ccdee"
                            ></path>
                            <path
                              d="M6215 1154H896c-54 0-97-43-97-97s43-97 97-97h5319c54 0 97 43 97 97s-44 97-97 97zM1478 850c-150 0-271-122-271-272s122-272 271-272c150 0 272 122 272 272s-122 272-272 272zm0-350c-42 0-77 35-77 78s35 78 77 78c43 0 77-35 77-78s-34-78-77-78zM2142 850c-149 0-272-122-272-272s123-272 272-272c150 0 273 122 273 272s-123 272-273 272zm0-350c-43 0-77 35-77 78s34 78 77 78c44 0 78-35 78-78 0-42-36-78-78-78zM2807 850c-150 0-272-122-272-272s122-272 272-272 272 122 272 272-122 272-272 272zm0-350c-43 0-77 35-77 78s34 78 77 78 78-35 78-78-35-78-78-78zM2062 2710c-6 0-13 0-18-1-53-10-88-61-76-114l195-1016c10-53 61-88 114-76 53 9 88 61 76 113l-195 1016c-10 46-50 78-96 78zM1786 2612c-25 0-50-10-70-29l-408-410c-37-37-37-100 0-137l408-408c38-38 100-38 138 0 37 37 37 99 0 137l-340 340 340 341c37 38 37 100 0 138-18 18-43 28-68 28zM2534 2612c-25 0-50-10-68-28-38-38-38-100 0-138l340-341-340-340c-38-38-38-100 0-137 37-38 100-38 137 0l408 408c38 37 38 100 0 137l-408 410c-20 19-44 29-69 29zM4232 2229h-922c-54 0-97-43-97-98 0-54 43-97 97-97h922c54 0 97 43 97 97 0 55-43 98-97 98zM4537 2710H3311c-54 0-97-43-97-97s43-97 97-97h1226c54 0 97 43 97 97s-43 97-97 97zM5733 2710h-850c-55 0-98-43-98-97V1597c0-54 43-97 98-97h850c55 0 98 43 98 97v1016c0 54-45 97-98 97zm-755-194h657v-822h-657zM3536 4263H1483c-54 0-97-43-97-97V3150c0-54 43-97 97-97h2053c54 0 97 43 97 97v1016c0 54-43 97-97 97zm-1956-194h1859v-822H1580zM5733 3247H4166c-54 0-97-43-97-97s43-97 97-97h1567c55 0 98 43 98 97s-45 97-98 97zM5733 3755H4166c-54 0-97-43-97-97s43-97 97-97h1567c55 0 98 43 98 97s-45 97-98 97zM5733 4262H4166c-54 0-97-43-97-97s43-97 97-97h1567c55 0 98 43 98 97s-45 97-98 97z"
                              fill="#9ccdee"
                              opacity="0.45"
                              data-original="#9ccdee"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Enterprise Web Applications</h2>
                        <p>
                          Developing scalable, secure, and maintainable web
                          applications for large-scale businesses.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M16.5 4h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1zM20.5 31h-11A2.503 2.503 0 0 1 7 28.5v-7a.5.5 0 0 1 1 0v7c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-17a.5.5 0 0 1 1 0v17c0 1.378-1.121 2.5-2.5 2.5z"
                              fill="#cb9cee"
                              opacity="1"
                              data-original="#cb9cee"
                            ></path>
                            <path
                              d="M22.5 5a.5.5 0 0 1-.5-.5v-1c0-.827-.673-1.5-1.5-1.5h-11C8.673 2 8 2.673 8 3.5v1a.5.5 0 0 1-1 0v-1C7 2.122 8.121 1 9.5 1h11C21.879 1 23 2.122 23 3.5v1a.5.5 0 0 1-.5.5zM14.5 25h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1zM17.5 27h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1zM19.5 23h-9a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1zM9 14c-1.379 0-2.5-1.122-2.5-2.5S7.621 9 9 9s2.5 1.122 2.5 2.5S10.379 14 9 14zm0-4c-.827 0-1.5.673-1.5 1.5S8.173 13 9 13s1.5-.673 1.5-1.5S9.827 10 9 10zM9 20a6.98 6.98 0 0 1-4.739-1.862.5.5 0 0 1-.146-.487A3.477 3.477 0 0 1 7.5 15h3a3.48 3.48 0 0 1 3.386 2.65.5.5 0 0 1-.146.487A6.98 6.98 0 0 1 9 20zm-3.827-2.393c2.162 1.801 5.492 1.801 7.654 0A2.48 2.48 0 0 0 10.5 16h-3a2.48 2.48 0 0 0-2.327 1.607z"
                              fill="#cb9cee"
                              opacity="1"
                              data-original="#cb9cee"
                            ></path>
                            <path
                              d="M9 20c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zM9 7c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zM4.5 22.95c-.276 0-.5-.174-.5-.45v-.1a.5.5 0 0 1 1 0c0 .276-.224.55-.5.55zM4.5 24.95c-.276 0-.5-.174-.5-.45v-.1a.5.5 0 0 1 1 0c0 .276-.224.55-.5.55zM4.5 26.95c-.276 0-.5-.174-.5-.45v-.1a.5.5 0 0 1 1 0c0 .276-.224.55-.5.55zM24.34 27h-.84a.5.5 0 0 1 0-1h.437l.245-1.135a.498.498 0 0 1 .371-.38 4.791 4.791 0 0 0 1.367-.571.5.5 0 0 1 .529.005l.99.633.613-.618-.633-.982a.501.501 0 0 1-.007-.531 4.76 4.76 0 0 0 .57-1.367.502.502 0 0 1 .378-.372l1.139-.253v-.857l-1.139-.253a.502.502 0 0 1-.378-.372 4.788 4.788 0 0 0-.57-1.367.497.497 0 0 1 .006-.53l.634-.991-.612-.612-.991.634a.498.498 0 0 1-.529.005 4.815 4.815 0 0 0-1.367-.571.498.498 0 0 1-.371-.38L23.937 14H23.5a.5.5 0 0 1 0-1h.84a.5.5 0 0 1 .488.395l.267 1.233c.366.111.725.261 1.071.448l1.074-.687a.5.5 0 0 1 .623.068l1.181 1.18a.5.5 0 0 1 .067.623l-.687 1.074c.187.347.337.706.448 1.073l1.235.274a.5.5 0 0 1 .392.488v1.66a.5.5 0 0 1-.392.488l-1.235.274a5.767 5.767 0 0 1-.448 1.072l.686 1.064a.498.498 0 0 1-.065.623l-1.181 1.19a.5.5 0 0 1-.624.069l-1.074-.687a5.815 5.815 0 0 1-1.071.448l-.267 1.233a.5.5 0 0 1-.488.397z"
                              fill="#cb9cee"
                              opacity="0.45"
                              data-original="#cb9cee"
                            ></path>
                            <path
                              d="M24.553 22.768a.5.5 0 0 1-.211-.953A2.01 2.01 0 0 0 25.5 20a2.002 2.002 0 0 0-2.777-1.843.5.5 0 1 1-.39-.92A3.004 3.004 0 0 1 26.5 20a3.011 3.011 0 0 1-1.736 2.721.498.498 0 0 1-.211.047zM26 10h-6c-1.103 0-2-.897-2-2s.897-2 2-2h6c1.103 0 2 .897 2 2s-.897 2-2 2zm-6-3a1.001 1.001 0 0 0 0 2h6a1.001 1.001 0 0 0 0-2z"
                              fill="#cb9cee"
                              opacity="0.45"
                              data-original="#cb9cee"
                            ></path>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Mobile Applications</h2>
                        <p>
                          Leveraging Angular with Ionic or NativeScript for
                          building high-quality mobile apps.
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="itemWrap">
                      <div className="imgWrap">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="62"
                          height="62"
                          x="0"
                          y="0"
                          viewBox="0 0 682.667 682.667"
                        >
                          <g>
                            <defs>
                              <clipPath id="a" clipPathUnits="userSpaceOnUse">
                                <path
                                  d="M0 512h512V0H0Z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                              </clipPath>
                              <clipPath id="b" clipPathUnits="userSpaceOnUse">
                                <path
                                  d="M0 512h512V0H0Z"
                                  fill="#dcdc30"
                                  opacity="1"
                                  data-original="#dcdc30"
                                ></path>
                              </clipPath>
                            </defs>
                            <g
                              clip-path="url(#a)"
                              transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                            >
                              <path
                                d="M0 0h-206v354.488h492V0H80"
                                transform="translate(216 41.145)"
                                fill="none"
                                stroke="#dcdc30"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="22.926"
                                stroke-dasharray="none"
                                data-original="#dcdc30"
                              ></path>
                              <path
                                d="M10 470.854h492v-75.221H10Z"
                                fill="none"
                                stroke="#dcdc30"
                                stroke-width="20"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-miterlimit="22.926"
                                stroke-dasharray="none"
                                data-original="#dcdc30"
                              ></path>
                            </g>
                            <path
                              d="M0 0h15.389m-61.404 0h15.389m76.641 0h15.388"
                              transform="matrix(1.33333 0 0 -1.33333 536.698 105.01)"
                              fill="none"
                              stroke="#dcdc30"
                              stroke-width="20"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="22.926"
                              stroke-dasharray="none"
                              data-original="#dcdc30"
                            ></path>
                            <path
                              d="M203.626 189.812h96.684V93.127h-96.684zm145.907 0h96.685V93.127h-96.685zm-291.815 0h96.684V93.127H57.718Z"
                              transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                              fill="none"
                              stroke="#dcdc30"
                              stroke-width="20"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="22.926"
                              stroke-dasharray="none"
                              data-original="#dcdc30"
                              opacity="0.45"
                            ></path>
                            <path
                              d="M0 0v13.449M-15.45-46.9H0v15.449M-62.069-46.9h15.357m-61.977 0h15.357m-61.977 0h15.357m-61.977 0h15.358m-61.978 0h15.358m-61.977 0h15.356m-61.976 0h15.357M-388.5-31.451V-46.9h15.449M-388.5 13.449V0m15.449 60.35H-388.5V44.9m62.069 15.45h-15.357m61.976 0h-15.356m61.977 0h-15.358m61.978 0h-15.358m61.977 0h-15.357m61.977 0h-15.357m61.977 0h-15.357M0 44.9v15.45h-15.45"
                              transform="matrix(1.33333 0 0 -1.33333 594.957 300.965)"
                              fill="none"
                              stroke="#dcdc30"
                              stroke-width="20"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="22.926"
                              stroke-dasharray="none"
                              data-original="#dcdc30"
                              opacity="0.45"
                            ></path>
                            <g
                              clip-path="url(#b)"
                              transform="matrix(1.33333 0 0 -1.33333 0 682.667)"
                            >
                              <path
                                d="M0 0c5.508 0 10 4.492 10 10 0 5.507-4.492 10-10 10s-10-4.493-10-10C-10 4.492-5.508 0 0 0"
                                transform="translate(256 31.146)"
                                fill="#dcdc30"
                                data-original="#dcdc30"
                                opacity="0.45"
                              ></path>
                            </g>
                          </g>
                        </svg>
                      </div>
                      <div className="dataWrap">
                        <h2>Component Development</h2>
                        <p>
                          Creating reusable, efficient components that can be
                          utilized across different parts of your application to
                          reduce development time and cost.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="staffAugFaqWrap">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-8">
                <div class="ttlWrap ttlCenter">
                  <h2>FAQ</h2>
                </div>
                <div class="accordion" id="accordionExample">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                      <button
                        class="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        What makes Angular different from other frameworks?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      class="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <p>
                          Angular is a comprehensive framework that offers
                          built-in support for functionalities like routing,
                          forms management, and client-server communication,
                          reducing the need for third-party libraries.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Can Angular be used for both frontend and backend
                        development?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <p>
                          Angular is primarily used for frontend development,
                          but it can be integrated with various backend
                          technologies for full-stack development.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                      <button
                        class="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        How does Angular ensure application security?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <p>
                          Angular provides built-in protection against common
                          web vulnerabilities such as cross-site scripting (XSS)
                          by sanitizing values to be displayed in the DOM.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="staffAugItroWrap staffAugValueWrap dotNetValueWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imgWrap">
                  <img
                    src={AngularDevelopmentImg2}
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap dataWrapPadRt">
                  <h2>Why Choose Us for Your Angular Projects?</h2>
                  <ul>
                    <li>
                      <strong>1. Proven Expertise:</strong> Our team has
                      extensive experience in Angular development, ensuring that
                      we can tackle projects of any complexity.
                    </li>
                    <li>
                      <strong>2. Customized Solutions:</strong> We tailor our
                      Angular development services to meet the unique
                      requirements of your business, ensuring a solution that
                      aligns with your objectives.
                    </li>
                    <li>
                      <strong>3. Agile Methodology:</strong> We adopt an agile
                      development approach to ensure flexibility, transparency,
                      and timely delivery of your project.
                    </li>
                    <li>
                      <strong>4. Ongoing Support:</strong> Our commitment to
                      your success extends beyond project completion, offering
                      ongoing support and maintenance to ensure your application
                      remains up-to-date and performs optimally.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="servCaseStudyWrap nodeJsCsStudy">
          <div class="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ttlWrap">
                  <h2>Angular Development Case Studies</h2>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-md-12">
                <ul>
                  <li>
                    <div class="itemWrap bgClr1">
                      <div className="dataWrap">
                        <h2>
                          Case Study 1: Financial Analytics SPA for a FinTech
                          Company
                        </h2>
                        <p>
                          <strong>Client:</strong> A leading FinTech startup
                          seeking to develop a sophisticated financial analytics
                          single-page application.
                        </p>
                        <p>
                          <strong>Solution:</strong> Utilized Angular to build a
                          highly interactive and responsive SPA that provides
                          real-time financial data analysis and visualization.
                        </p>
                        <p>
                          <strong>Outcome:</strong> The application drastically
                          improved the client's data processing capabilities,
                          enhancing user engagement and decision-making
                          processes.
                        </p>
                      </div>
                      <div className="imgWrap">
                        <img
                          src={productsliderImg1}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="itemWrap bgClr2">
                      <div className="imgWrap">
                        <img
                          src={productsliderImg2}
                          className="img-fluid"
                          alt=""
                        />
                      </div>
                      <div className="dataWrap">
                        <h2>
                          Case Study 2: E-commerce Platform for a Retail
                          Business
                        </h2>
                        <p>
                          <strong>Client:</strong> An online retail company
                          looking to revamp their e-commerce platform.
                        </p>
                        <p>
                          <strong>Solution:</strong> Developed a feature-rich,
                          scalable e-commerce website using Angular, improving
                          site performance and user experience.
                        </p>
                        <p>
                          <strong>Outcome:</strong> The new platform led to a
                          significant increase in conversion rates and customer
                          satisfaction.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="reachOutWrap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="dataWrap">
                <h3>
                  Ready to take your web or mobile app project to the next level
                  with Angular? Contact <i>Hummingtec</i> today to learn how our
                  Angular development expertise can benefit your business.
                </h3>
                <button className="btn" onClick={() => setLgShow(true)}>
                  Contact Us
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className="contactUsPopup"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="titleWrap">
            <h2>Let's get in touch</h2>
            <p>
              Kindly fill out the form below, and our team will promptly respond
              to your inquiries.
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <ul className="formList">
              <li>
                <div className="inputField">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </li>
              <li>
                <div className="inputField">
                  <label>Email Address</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </li>
              <li>
                <div className="inputField">
                  <label>Mobile Number</label>
                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                </div>
              </li>
              <li>
                <div className="inputField selectField">
                  <label>I'm interested in:</label>
                  <select
                    name="interest"
                    value={formData.interest}
                    onChange={handleChange}
                  >
                    <option value="">Select an option</option>
                    <option>Artificial Intelligence</option>
                    <option>Machine Learning</option>
                    <option>Custom GPT</option>
                    <option>Blockchain/Etherium</option>
                    <option>E-Commerce/Shopping Cart</option>
                    <option>Salesforce CRM</option>
                    <option>Zoho CRM</option>
                    <option>Custom CRM</option>
                    <option>Website Development</option>
                    <option>SEO</option>
                    <option>Social Media Management</option>
                    <option>Mobile Application Development</option>
                    <option>Custom Application Development</option>
                    <option>Security and Testing</option>
                    <option>Other</option>
                  </select>
                </div>
              </li>
              <li className="full">
                <div className="inputField">
                  <label>Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>
              </li>
              <li className="full">
                <div className="ctaWrap">
                  <button type="submit" className="btnSubmti">
                    Submit
                  </button>
                </div>
              </li>
            </ul>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        show={showThankYou}
        onHide={() => setShowThankYou(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        className="contactUsPopup"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="thankYouPopup">
            <h3>Thank you for contacting us!</h3>
            <p>We will respond to your inquiry shortly.</p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default Angular;
